import { ConnectedCalendarsTile } from './connected_calendars_tile'
import { ConnectedVideoConferencingTile } from './connected_video_conferencing_tile'
import { PendingUsersTile } from './pending_users_tile'

export const UsersStats = () => (
  <>
    <PendingUsersTile />
    <ConnectedCalendarsTile />
    <ConnectedVideoConferencingTile />
  </>
)
